/* unplugin-vue-components disabled */import SharedFilesEmpty from './sh-files-empty.vue'
import SharedFilesTable from './sh-files-table.vue'


import $global from 'stores/global'
import {get_store} from 'stores/files'
import $profile from 'stores/profile'
import {DOCUMENT} from 'consts/ftypes'
import {API2_SHARED_FILES} from 'consts/api2'
import {FTYPES} from 'consts/ftypes'

const DEF_LIMIT = 20

const __default__ = {
  data() {
    return {
      initial_load: true,
      load_params: {skip: 0, limit: DEF_LIMIT, filter: ''},
      active: false,
      error: false,
      highlight: '',
      shared_files: get_store(DOCUMENT.type, undefined, API2_SHARED_FILES),
    }
  },
  computed: {
    is_admin () {
      return $profile.is_admin
    },
    loading () {
      return this.shared_files.loading
    },
    store_loaded () {
      return this.shared_files.loaded
    },
    show_loading () {
      // store is loading for the first time
      return !this.shared_files.loaded && this.initial_load
    },
    show_refreshing () {
      // was loaded already and loading again
      return !this.shared_files.loaded && !this.initial_load
    },
    show_empty () {
      // loaded but still no files, checking total (not this.shared_files.length) because files can be filtered
      return this.shared_files.loaded && this.shared_files.total === 0
    },
  },
  async mounted() {
    if (!$profile.is_admin) {
      await $global.goToChats()
      return
    }
    this.initial_load = true

    await this.loadItems({total: true})
    this.initial_load = false
  },
  beforeUnmount(){
    this.shared_files?.watch.abort()
  },
  methods: {
    async loadItems({total = false, ...ev} = {}){
      this.load_params = {...this.load_params, ...ev}
      await this.shared_files.load({...this.load_params, total})
      this.highlight = ev.name || this.load_params.name || ''
    },
    async onUpload(files) {
      if (files.length > 1000) {
        $utils.toasts.error('You can upload maximum 1000 files at once.')
        return
      }
      const items = Array.from(files)
      const max_size = 200 * 1024 * 1024
      if (items.some(f => f.size > max_size)) {
        $utils.toasts.error('The file size must not exceed 200 MB.')
        return
      }

      await this.shared_files.uploadMany(items, {
        resolve: async () => await this.loadItems({total: true})
      })
    },
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'sh-files',
  setup(__props, { expose: __expose }) {
  __expose();

const STATUSES = [
  'Uploaded', 'Processing', 'Processed', 'Failed-Processing'
]

const EXTS = [...FTYPES.document.exts, '.doc', '.ppt', '.xls', '.xlsx', '.xml'].map(ext => ext.toUpperCase().slice(1)).sort()

const __returned__ = { DEF_LIMIT, STATUSES, EXTS, get $global() { return $global }, get get_store() { return get_store }, get $profile() { return $profile }, get DOCUMENT() { return DOCUMENT }, get API2_SHARED_FILES() { return API2_SHARED_FILES }, get FTYPES() { return FTYPES }, SharedFilesEmpty, SharedFilesTable }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})